<template>
  <div class="container results-container" v-if="results">
    <p class="results-totals" v-if="results.searched">
      Results {{ results.startResults }} &ndash; {{ results.endPage }} of
      {{ totals }}
    </p>
    <div class="columns results" v-for="item in results.results" :key="item.id">
      <div class="column is-one-fifth">
        <img
          v-if="item._source.image"
          :src="'http://www.getty.edu/' + item._source.image"
          alt=""
        />
      </div>
      <div class="column">
        <a v-if="item._source.title" :href="item._source.url"
          ><h2>{{ item._source.title }}</h2></a
        >
        <a v-else :href="item._source.url">
          <h2 class="url-title">{{ item._source.url }}</h2>
        </a>
        <h3 v-if="item._source.DESCRIPTION">
          {{ item._source.DESCRIPTION }}
        </h3>
        <h3 v-if="item._source.description">
          {{ item._source.description }}
        </h3>
        <div v-if="hasTags(item)" class="tag-container">
          <span>Tags:</span>
          <div v-if="item._source['metatag.grades']">
            <div v-for="items in filterTerms.grade" :key="items.id">
              <span
                class="tag"
                v-if="item._source['metatag.grades'].includes(items.id)"
              >
                {{ items.name }}
              </span>
            </div>
          </div>
          <div v-if="item._source['metatag.subjects']">
            <div v-for="items in filterTerms.subject" :key="items.id">
              <span
                class="tag"
                v-if="item._source['metatag.subjects'].includes(items.id)"
              >
                {{ items.name }}
              </span>
            </div>
          </div>
          <div v-if="item._source['TYPE']">
            <div v-for="items in filterTerms.type" :key="items.id">
              <span class="tag" v-if="item._source['TYPE'].includes(items.id)">
                {{ items.name }}
              </span>
            </div>
          </div>
          <div v-if="item._source['metatag.location']">
            <div v-for="items in filterTerms.location" :key="items.id">
              <span
                class="tag"
                v-if="item._source['metatag.location'].includes(items.id)"
              >
                {{ items.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchMusEdResults",
  data() {
    return {};
  },
  props: {
    results: Object,
    filterTerms: Object
  },
  mounted() {
    this.$emit("mounted:results");
  },
  components: {},
  computed: {
    totals() {
      if (this.results.totals.value != undefined) {
        return this.results.totals.value;
      }
      return this.results.totals;
    }
  },
  methods: {
    hasTags(item) {
      return (
        item._source["metatag.grades"] ||
        item._source["metatag.subjects"] ||
        item._source["TYPE"] ||
        item._source["metagtag.location"]
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.results-container {
  width: 100%;
  margin-bottom: 1em !important;
  .results {
    border-top: 1px solid $black;
    &:last-child {
      border-bottom: 1px solid $black;
    }
    &-totals {
      margin: 0 0 1em 0;
    }
    .url-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 300px;
      direction: rtl;
    }
  }
  .tag-container {
    text-align: left;
    div {
      display: inline;
    }
    .tag {
      background-color: darken($white, 5%);
      margin: 0 0.25em;
      padding: 0.25em;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
